/**
 * frontend/src/panels/readme.ts
 *
 * edit the puzzle README.md (results table + writeup after %%%)
 */

import { api } from '../api.ts';
import { h } from '../dom.ts';
import { actions, getState, subscribe } from '../state.ts';
import type { PanelDefinition } from '../workspace.ts';

export const readmePanel: PanelDefinition = {
    id: 'readme',
    title: 'README',
    create(container) {
        const textarea = h('textarea', {
            className: 'fill',
            spellcheck: false,
            placeholder: 'no README.md yet: profile the puzzle to generate one, or start writing.',
        });
        const status = h('span', { className: 'dim' });
        const saveButton = h('button', { className: 'link', disabled: true, onClick: () => save() }, 'save');
        let saved = '';
        let shownFor = '';

        const setStatus = (text: string, className = 'dim') => {
            status.textContent = text;
            status.className = className;
        };

        const save = async () => {
            const { year, day } = getState().puzzle;
            try {
                await api.saveReadme(year, day, textarea.value);
                saved = textarea.value;
                saveButton.disabled = true;
                setStatus('saved', 'ok');
                await actions.refreshDetail();
            } catch (error) {
                setStatus(error instanceof Error ? error.message : String(error), 'error');
            }
        };

        textarea.addEventListener('input', () => {
            saveButton.disabled = textarea.value === saved;
            setStatus(textarea.value === saved ? '' : 'unsaved changes');
        });

        textarea.addEventListener('keydown', (event) => {
            if ((event.metaKey || event.ctrlKey) && event.key === 's') {
                event.preventDefault();
                save();
            }
        });

        container.append(
            h(
                'div',
                { className: 'panel' },
                h(
                    'div',
                    { className: 'toolbar' },
                    saveButton,
                    h('span', { className: 'dim' }, 'everything after %%% is your writeup; the table above it is regenerated by profile'),
                    h('span', { className: 'spacer' }),
                    status,
                ),
                textarea,
            ),
        );

        const render = () => {
            const { puzzle, detail } = getState();
            if (!detail) return;
            const key = `${puzzle.year}/${puzzle.day}`;
            const content = detail.readme ?? '';
            // don't clobber an in-progress edit of the same puzzle unless the server copy changed underneath (e.g. profile ran)
            if (key === shownFor && textarea.value !== saved && content === saved) return;
            shownFor = key;
            saved = content;
            textarea.value = content;
            saveButton.disabled = true;
            setStatus('');
        };

        const unsubscribe = subscribe(render, ['detail']);
        render();
        return { dispose: unsubscribe };
    },
};
